import { EventListPresenterState } from "../../../blocks/EventListPresenter/state";
import { Event } from "../../../contracts";
import { BaseDict } from "../../../blocks/EventListPresenter/dict";

export const getAggregateCardProps = (state: EventListPresenterState, event: Event, dict: BaseDict) => {
    return {
        event,
        sportId: event.sportId,
        handler: state.openGameTranspiler.bind(state, event),
        dict,
    }
}